//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useState, useEffect, useContext, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import access from "config/access";

// custom pages
import { mpcDetailStyles } from "./styles";
import product from "apis/Product/product";
import Context from "context/context";

// material-ui
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
// material-ui icons
import ArrowBackOutlinedIcon from "@material-ui/icons/ArrowBackOutlined";

// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      "&.MuiOutlinedInput-root": {
        marginTop: 0,
        borderRadius: 20,
      },
    },
  },
})(TextField);

export default function ViewShipTo(props) {
  const { state, dispatch } = useContext(Context);
  const { getProductDetail} = product();
  const history = useHistory();
  const location = useLocation();
  const classes = mpcDetailStyles();
  const [mpc, setMpc] = useState({});
  const [data, setData] = useState({});
  const [dataClone, setDataClone] = useState({});
  const [updated, setUpdated] = useState({});
  const [edit, setEdit] = useState(false);

  // setting mpc details
  // useEffect(() => {
  //   if (location.state && location.state.mpc) {
  //     setMpc(location.state.mpc);
  //     return;
  //   } else {
  //     history.goBack();
  //   }
  // }, []);

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Product Detail"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (location?.state?.ProductId) {
      handleGet();
      return;
    }
    history.goBack();
  }, []);

  // authorized members api func
  const handleGet = async () => {
    try {
      let id = location?.state?.ProductId;
      console.log(id,"thisis id")
      let res = await getProductDetail(id);
      if (res) {
        setData(res?.data);
        setDataClone(res?.data);
      }
    } catch (e) {
      console.log({ e });
    }
  };



  let editObj = {
    redemption_percentage: { edit: edit, type: "number" },
    is_active: {
      edit: edit,
      type: "select",
      options: [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" },
      ],
    },
  };


  let offset = location?.state?.offset;

  return (
    <React.Fragment>
      <Grid container style={{ padding: 10 }}>
        <Grid item xs={6}>
          <Button
            className={classes.editBtn}
            onClick={() => {
              history.push("/dashboard/product", { offset });
            }}
          >
            Back
          </Button>
        </Grid>
      </Grid>
     <Grid container>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>Product Details</div>
        </div>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Product Code</span> :{" "}
            {data.product_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Product Short Description</span> :{" "}
            {data.product_short_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Product Primary Class Id</span> :{" "}
            {data.product_primary_class_id}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
            Product Brand Name Code
            </span>{" "}
            : {data.product_brand_name_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Label Class Code</span> :{" "}
            {data.label_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
            Dental Product Full Display Description
            </span>{" "}
            : {data.dental_product_full_display_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Primary Major Class Code</span> :{" "}
            {data.primary_major_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>
            Primary Major Class Description
            </span>{" "}
            : {data.primary_major_class_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Primary Major Sub Major Class Code</span> :{" "}
            {data.primary_majorsubmajor_class_code}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Primary Major Sub Major Class Description</span> :{" "}
            {data.primary_majorsubmajor_class_description}
          </div>
        </Grid>
        <Grid xs={12} lg={6} className={classes.grid}>
          <div>
            <span className={classes.gridSpan}>Load Date</span> :{" "}
            {data.load_date}
          </div>
        </Grid>

        <Grid xs={12} lg={6} className={classes.grid}>
         <div>
              <span className={classes.gridSpan}>Status </span> :{" "}
              {typeof data?.["is_active"] == "boolean" ? (
                data?.["is_active"] ? (
                  <span className={classes.activeSpan}>Active</span>
                ) : (
                  <span className={classes.inActiveSpan}>Inactive</span>
                )
              ) : (
                data["is_active"]
              )}
            </div>
        </Grid>
      </Grid>

    </React.Fragment>
  );
}
